import {
  Container,
  Button,
  Box,
  ButtonGroup,
  MenuItem,
  Select,
  Typography,
  useMediaQuery,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Checkbox,
  Paper,
  Pagination,
  TableSortLabel,
  CircularProgress,
  IconButton,
  Tooltip,
  Card,
  CardContent,
  CardHeader,
} from "@mui/material";

import useFetchData from "../../../hooks/useFetchData";
import { useState } from "react";
import { Theme } from "@mui/system";
import { useNavigate, useParams } from "react-router-dom";
import { ContractorRowData } from "./type";
import PageTitle from "../../molecules/PageTitle";
import { SortState } from "../../../common/const";
import { DataGrid, GridColDef, jaJP } from "@mui/x-data-grid";
import BackButton from "../../atoms/Button/BrowserBackButton";
import UpdateButton from "../../atoms/Button/UpdateButton";
import {
  CustomContainer,
  StyledDataGrid,
  customDataGridLocaleTextAll,
  customDataGridLocaleTextLoading,
  customDataGridLocaleTextNoData,
} from "../../../styles/styles";
import EditIcon from "@mui/icons-material/Edit";
import IconButtonWithTooltip from "../../atoms/Button/IconButtonWithTooltip";
import NavigateButton from "../../atoms/Button/NavigateButton";

const ContractorListPage = () => {
  const { autoBuildingId } = useParams(); //URLパラメータから取得

  // call indexContracts API
  const { data, isLoading, error } = useFetchData<ContractorRowData[]>(
    process.env.REACT_APP_API_ENDPOINT +
      "/buildings/" +
      autoBuildingId +
      "/contracts",
    "contracts",
  );

  const processedData =
    data?.map((contract: any) => ({
      ...contract,
      buildingId: contract.building.buildingId,
      buildingManagementId: contract.building.buildingManagementId,
      buildingName: contract.building.buildingName,
      buildingAddress: contract.building.buildingAddress,
    })) || [];

  console.log("プロセスデータ" + JSON.stringify(processedData));

  const navigate = useNavigate();

  // ソート状態を追加
  const [sortState, setSortState] = useState<SortState>({
    column: "",
    order: "asc",
  });
  // ソートのイベントハンドラを変更

  // ページ番号の状態を追加
  const [currentPage, setCurrentPage] = useState(1);

  // ページネーションのイベントハンドラを追加
  const handlePageChange = (
    _event: React.ChangeEvent<unknown>,
    value: number,
  ) => {
    setCurrentPage(value);
    console.log("Page changed to:", value);
  };

  const handleTransitionButtonClick = (
    action: string,
    row: ContractorRowData,
  ) => {
    console.log(action, row);
    if (action === "編集") {
      // navigate("/contractor-form", { state: { autoContractId: row.autoContractId } });
      navigate(
        `/buildings/${autoBuildingId}/contractors/${row.autoContractId}/edit`,
      );
    } else if (action === "新規追加") {
      navigate(`/buildings/${autoBuildingId}/contractors/new`);
    } else {
      alert("【" + action + "】" + JSON.stringify(row));
    }
  };

  const isSmallScreen = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("sm"),
  );

  if (isLoading) {
    <Box display="flex" justifyContent="center" alignItems="center">
      <CircularProgress /> {/* MUIの CircularProgress コンポーネント */}
    </Box>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  const columns: GridColDef[] = [
    {
      field: "state",
      headerName: "状態",
      sortable: false,
      flex: 0.5,
      renderCell: (params: { row: ContractorRowData }) => {
        const row = params.row as ContractorRowData;
        return <span>{row.isEnabled ? "有効" : "無効"}</span>;
      },
    },
    {
      field: "isProximityKeyContract",
      headerName: "「手動でドアを開ける」ボタン",
      sortable: false,
      flex: 0.5,
      renderCell: (params: { row: ContractorRowData }) => {
        const row = params.row as ContractorRowData;
        return <span>{row.isProximityKeyContract ? "無効" : "有効"}</span>;
      },
    },
    {
      field: "canSetKeyExpiration",
      headerName: "時限鍵",
      sortable: false,
      flex: 0.5,
      renderCell: (params: { row: ContractorRowData }) => {
        const row = params.row as ContractorRowData;
        return <span>{row.canSetKeyExpiration ? "有効" : "無効"}</span>;
      },
    },
    {
      field: "contractId",
      headerName: "契約システムID",
      flex: 1,
      renderCell: (params) => (
        <Tooltip title={params.value}>
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "roomNumber",
      headerName: "部屋番号",
      flex: 0.5,
      renderCell: (params) => (
        <Tooltip title={params.value}>
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "contractManagementId",
      headerName: "契約管理ID",
      flex: 1,
      renderCell: (params) => (
        <Tooltip title={params.value}>
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "contractorName",
      headerName: "契約者氏名",
      flex: 1,
      renderCell: (params) => (
        <Tooltip title={params.value}>
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "phoneNumber",
      headerName: "電話番号",
      flex: 1,
      renderCell: (params) => (
        <Tooltip title={params.value}>
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "email",
      headerName: "メールアドレス",
      flex: 1,
      renderCell: (params) => (
        <Tooltip title={params.value}>
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "memo",
      headerName: "メモ",
      flex: 2,
      renderCell: (params) => (
        <Tooltip title={params.value}>
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "action",
      headerName: "操作",
      sortable: false,
      flex: 1,
      renderCell: (params: { row: ContractorRowData }) => {
        const row = params.row as ContractorRowData;
        return (
          <IconButtonWithTooltip
            title="編集"
            onClick={() => handleTransitionButtonClick("編集", row)}
            icon={<EditIcon />}
          />
        );
      },
    },
  ];

  return (
    <CustomContainer maxWidth={false}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        {/* ページタイトルコンポーネント */}
        <PageTitle title="契約者一覧" />
        <NavigateButton to={"/buildings"} buttonTitle={"管理物件一覧"} />
      </Box>

      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="flex-end"
        marginBottom={2}
      >
        <Box maxWidth="lg">
          <Table size="small">
            <TableBody>
              <TableRow>
                <TableCell component="th" scope="row">
                  物件システムID:
                </TableCell>
                <TableCell>{processedData[0]?.buildingId || ""}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="th" scope="row">
                  取付先コード（物件管理ID）:
                </TableCell>
                <TableCell>
                  {processedData[0]?.buildingManagementId || ""}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="th" scope="row">
                取付先名（物件名称）:
                </TableCell>
                <TableCell>{processedData[0]?.buildingName || ""}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="th" scope="row">
                  物件住所:
                </TableCell>
                <TableCell>{processedData[0]?.buildingAddress || ""}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Box>

        <div style={{ display: "flex" }}>
          <Button
            onClick={() =>
              handleTransitionButtonClick("新規追加", {} as ContractorRowData)
            }
            variant="outlined"
            color="primary"
            style={{
              marginRight: "8px",
              marginBottom: isSmallScreen ? "8px" : "0",
            }}
          >
            新規契約者登録
          </Button>
          <UpdateButton />
        </div>
      </Box>

      <div style={{ height: 700, width: "100%" }}>
        <StyledDataGrid
          rows={processedData}
          columns={columns}
          getRowId={(row) => row.autoContractId}
          disableRowSelectionOnClick
          localeText={
            isLoading
              ? customDataGridLocaleTextLoading
              : processedData.length === 0
                ? customDataGridLocaleTextNoData
                : customDataGridLocaleTextAll
          }
        />
      </div>
    </CustomContainer>
  );
};

export default ContractorListPage;
